module.exports = __webpack_public_path__ + "static/img/ccst.6a16e765.png";